import { List, SpinLoading, Form } from "antd-mobile";
import React, { useEffect, useState } from "react";
import { _ListLessonPlans } from "../../models/lessonPlans";
import { groupByMultiple } from "../../utils";
import { Card, Button } from "react-bootstrap";
import { jsonToQuery, lowerCase, momentDate, upperCase } from "../../utils";
import $ from "jquery";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";

const AttendanceTypeSelectView = (props) => {
  const [loader, setLoader] = useState(false);
  const [hostelId, setHostelId] = useState("");
  const [hostelVal, setHostelVal] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [floorData, setFloorData] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [roomList, setRoomList] = useState([]);

  const paramsField = (fieldName) => props?.dataParams?.[fieldName] || "";
  const [selectedAttendanceeType, setSelectedAttendanceType] = useState(
    props.dataSource && props.dataSource.length > 0
      ? props.dataSource[0].attendance_type
      : ""
  );
  const [selectedAttendanceeTypeName, setSelectedAttendanceTypeName] = useState(
    props.dataSource && props.dataSource.length > 0
      ? props.dataSource[0].attendance_typename
      : ""
  );
  const [selectedDate, setSelectedDate] = useState(
    momentDate(new Date(), "YYYY-MM-DD")
  );
  const [selectedFloor, setSelectedFloor] = useState(
    props.dataSource && props.dataSource.length > 0
      ? props.dataSource[0].floor
      : ""
  );
  const [selectedFloorName, setSelectedFloorName] = useState(
    props.dataSource && props.dataSource.length > 0
      ? props.dataSource[0].floor_name
      : ""
  );

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    const form = new FormData();
    form.append("staff_id", props.context.user.id);
    axios.post(ServiceUrl.MOB.GET_HOSTEL_DETAILS, form).then((res) => {
      if (res["data"].status == "1") {
        setHostelId(res["data"].hostel_id);

        let filteredArray = res["data"].data;
        let filteredFloorArray = res["data"].floor;
        
        // if (props.hostelAttendance.floor_id) {
        //   const floorArray = props.hostelAttendance.floor_id.split(",");
        //   if (floorArray) {
        //     filteredFloorArray = res["data"].floor
        //     .filter(
        //       (item) => floorArray.includes(String(item.id))


        //     );
        //     console.log(props.hostelAttendance.floor_id);

        //   }
        // }
        setCategoryList(filteredArray);
        setFloorData(filteredFloorArray);
        setFloorList(filteredFloorArray);
        setRoomList(res["data"].rooms);
        setLoader(false);
      }
    });
  };

  const topicList = (items) => {
    return items.map((item) => (
      <List.Item
        onClick={(e) => onTopicClick(item)}
        extra={
          <>
            {item.topic_periods_or_hours}
            {item.topic_periods_or_hours && `H`}
          </>
        }
        clickable
      >
        {item.topic_name}
      </List.Item>
    ));
  };

  const onfinish = (item) => {
    const attendance = [
      {
        attendance_type: selectedAttendanceeType,
        attendance_typename: selectedAttendanceeTypeName,
        date: selectedDate,
        floor: selectedFloor,
        floor_name: selectedFloorName,
        hostel_id: hostelVal,
        room_list: roomList,
      },
    ];
    if (props.onSuccess) props.onSuccess(attendance);
  };
  let cat;
  let floor;

  const handleChangeType = (e) => {
    setSelectedAttendanceType(e.target.value);
    const selectedOption = e.target.options[e.target.selectedIndex];
    const customAttributeValue = selectedOption.getAttribute("data-attr");
    const hostelval = selectedOption.getAttribute("data-key");
    setSelectedAttendanceTypeName(customAttributeValue);
    let filteredFloor = floorData.filter((item) => item.hostel_id == hostelval);
    setFloorList(filteredFloor);
    setHostelVal(hostelval);
  };
  return (
    <>
      <>
        <Card>
          <Card.Body>
            <Form
              name="from"
              id="attendance"
              onFinish={(e) => onfinish(e)}
              footer={
                <Button
                  type="submit"
                  variant="danger"
                  size="lg"
                  className="w-100"
                >
                  Search
                </Button>
              }
            >
              <Form.Item name="course_type" label="Attendance Date">
                <input
                  className="form-control form-control-sm fw-bold"
                  type="date"
                  size="sm"
                  onChange={(e) => setSelectedDate(e.target.value)}
                  max={momentDate(new Date(), "YYYY-MM-DD")}
                  defaultValue={selectedDate}
                />
              </Form.Item>

              <Form.Item name="attendance_type" label="Attendance Type">
                <select
                  className="form-select form-select-sm fw-bold"
                  onChange={(e) => {
                    handleChangeType(e);
                  }}
                  value={selectedAttendanceeType}
                >
                  <option value="">Select</option>
                  {categoryList.map((item) => {
                    return (
                      <option
                        value={item.id}
                        data-attr={item.attendence_name}
                        data-key={item.hostel_id}
                        selected={
                          selectedAttendanceeType == item.id ? "selected" : ""
                        }
                      >
                        {item.hostel_name} - {item.attendence_name}
                      </option>
                    );
                  })}
                </select>
              </Form.Item>
              <Form.Item name="attendance_floor" label="Attendance Floor">
                <select
                  className="form-select form-select-sm fw-bold"
                  onChange={(e) => {
                    setSelectedFloor(e.target.value);
                    const selectedOption =
                      e.target.options[e.target.selectedIndex];
                    const customAttributeValue =
                      selectedOption.getAttribute("data-attr");
                    setSelectedFloorName(customAttributeValue);
                  }}
                  value={selectedFloor}
                >
                  <option value="">Select</option>
                  {floorList.map((item) => {
                    return (
                      <option
                        value={item.id}
                        data-attr={item.floor_name}
                        selected={selectedFloor == item.id ? "selected" : ""}
                      >
                        {item.floor_name}
                      </option>
                    );
                  })}
                </select>
              </Form.Item>
            </Form>
          </Card.Body>
        </Card>
      </>
    </>
  );
};
export default AttendanceTypeSelectView;
